<template>
  <div>
    <section
      :style="data.style ? data.style :  isDark ? 'secondary' : ''"
      :class="`${isDark ? 'secondary white--text' : ''}  ${data.class}`"
    >
      <v-container fluid :class="`video py-0 ${ isDark ? 'white--text' : ''}`">
        <v-row justify="center" align="center">
          <v-col cols="12" sm="10" md="5" lg="5" xl="4" class="text-center">
            <v-row justify="center">
              <v-col cols="11" sm="12" md="9" lg="8" xl="7">
                <v-card v-if="data.video.url && data.video.thumbnail">
                  <v-img
                    :aspect-ratio="16/9"
                    :src="data.video.thumbnail"
                    @click="$eventBus.$emit('play_video',data.video.url)"
                  >
                    <v-row class="pa-2 fill-height">
                      <v-fade-transition>
                        <v-overlay :absolute="true" :value="true" :opacity="0.2">
                          <v-btn color="primary">
                            <v-icon small>fa-play</v-icon>
                          </v-btn>
                        </v-overlay>
                      </v-fade-transition>
                    </v-row>
                  </v-img>
                </v-card>
                <v-text-field
                  @change="onChange"
                  hide-details
                  :dark="isDark"
                  label="Video Thumbnail"
                  v-model="data.video.thumbnail"
                ></v-text-field>
                <v-text-field
                  hide-details
                  :dark="isDark"
                  label="Video Url"
                  @change="setVideoThumbnail"
                  v-model="data.video.url"
                ></v-text-field>
                <video-uploader class="mt-2" v-model="data.video"></video-uploader>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="11" sm="10" md="7" lg="7" xl="6">
            <v-text-field
              dense
              label="Title"
              @change="onChange"
              :dark="isDark"
              v-model="data.title"
            ></v-text-field>
            <v-textarea
              dense
              label="Description"
              @change="onChange"
              :dark="isDark"
              v-model="data.description"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <v-divider></v-divider>
    <v-container class="grey lighten-3">
      <v-row>
        <v-col cols="12">
          <v-switch
            label="Dark"
            dense
            @change="onChange"
            hide-details
            class="my-0 py-0"
            color="primary"
            v-model="data.dark"
          ></v-switch>
        </v-col>
        <v-col cols="12">
          <v-text-field dense label="Class" @change="onChange" v-model="data.class"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field dense label="Style" @change="onChange" v-model="data.style"></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import videoUploader from "@/components/admin/video-uploader";

export default {
  name: "PageVideoEdit",
  props: ["value"],
  components:{
    videoUploader
  },
  data() {
    return {};
  },
  computed: {
    data() {
      return this.value;
    },
    isDark() {
      return this.value.dark ? true : false;
    }
  },
  methods: {
    async setVideoThumbnail() {
      if (this.data.video.url) {
        if (this.data.video.url.includes("youtube")) {
          let id = this.$helpers.youtubeId(this.data.video.url);
          this.data.video.thumbnail = `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;
        }
        if (this.data.video.url.includes("vimeo")) {
          let id = this.$helpers.vimeoId(this.data.video.url);
          let thumb = await this.loadVimeoThumbnail(id);
          this.data.video.thumbnail = thumb;
        }
      }
      this.onChange();
    },
    async loadVimeoThumbnail(id) {
      try {
        let res = await this.$api.get(`vimeo-thumbnail/${id}`);
        return res;
      } catch (ex) {
        console.error(ex);
      }
      return "";
    },
    onChange() {
      this.$emit("change");
    }
  }
};
</script>

<style lang="scss">
.video-card {
  padding: 50px;

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 600px) {
    padding: 20px;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    padding: 20px;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    padding: 10px;
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    padding: 50px;
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    padding: 50px;
  }
}
.video a {
  text-decoration: none;
}
</style>